module.exports = __webpack_public_path__ + "img/research-group-7.c0cf7ea8.jpg";